export const ACTUAL_VS_BUDGET_WEEKLY = 'budget_vs_actual_weekly';
export const ACTUAL_VS_BUDGET_MONTHLY = 'budget_vs_actual_monthly';
export const VIEW_TYPE_WEEKLY = 'Weekly';
export const VIEW_TYPE_MONTHLY = 'Monthly';
export const STICKY_COLUMNS_COLUMN = ['ytd_spend_to_plan', 'channel', '_YTD', 'branch'];
export const ACTUAL_VS_BUDGET_CHANNEL = 'budget_vs_actual_channel_filter';
export const BUDGET_VS_ACTUAL_WEEKLY_TOTAL = 'budget_vs_actual_weekly_total';
export const BUDGET_VS_ACTUAL_MONTHLY_TOTAL = 'budget_vs_actual_monthly_total';
export const ACTUAL_VS_BUDGET_BRANCHES_WEEKLY = 'budget_vs_actual_branches_weekly';
export const ACTUAL_VS_BUDGET_BRANCHES_MONTHLY = 'budget_vs_actual_branches_monthly';
export const CURRENT_WEEK = 'Current Week';
export const CURRENT_MONTH = 'Current Month';
export const ACTUAL_VS_BUDGET_BRANCH_TOTAL_WEEKLY_FILE =
  'actual_vs_budget_branch_totals_weekly.xlsx';
export const ACTUAL_VS_BUDGET_BRANCH_TOTAL_MONTHLY_FILE =
  'actual_vs_budget_branch_totals_monthly.xlsx';
export const ACTUAL_VS_BUDGET_CHANNEL_WEEKLY_FILE = 'actual_vs_budget_channels_weekly.xlsx';
export const ACTUAL_VS_BUDGET_CHANNEL_MONTHLY_FILE = 'actual_vs_budget_channels_monthly.xlsx';
